import { WebElement } from 'z3k-config';
export function getIconIdByAliceView(alice_view) {
    switch (alice_view) {
        case WebElement.AliceView.Light:
        case WebElement.AliceView.Switch:
            return 315;
        case WebElement.AliceView.Socket:
            return 300;
        case WebElement.AliceView.Openable:
            return 319;
        case WebElement.AliceView.Ventilation:
            return 14;
        case WebElement.AliceView.Other:
        case WebElement.AliceView.NOT_CHOSEN:
        default:
            return null;
    }
}
